import Navbar from "@/components/home/Navbar";
import Hero from "@/components/home/Hero";
import Marquee from "@/components/home/Marquee";
import Chapters from "@/components/home/Chapters";
import Episodes from "@/components/home/Episodes";
import MusicVideos from "@/components/home/MusicVideos";
import Gallery from "@/components/home/Gallery";
import Founder from "@/components/home/Founder";
import Contact from "@/components/home/Contact";
import Footer from "@/components/home/Footer";
import ChatHost from "@/components/home/ChatHost";
import BackgroundMusic from "@/components/home/BackgroundMusic";
import DonationWall from "@/components/home/DonationWall";
import InstallPrompt from "@/components/home/InstallPrompt";

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-ink text-gray-100 overflow-x-clip">
      <Navbar />
      <Hero />
      <Marquee />
      <DonationWall />
      <Chapters />
      <Episodes />
      <MusicVideos />
      <Gallery />
      <Founder />
      <Contact />
      <Footer />
      <ChatHost />
      <BackgroundMusic />
      <InstallPrompt />
    </div>
  );
}
